<script setup lang="ts">
import CheckIntervalType = App.Enums.CheckIntervalType;
import CheckIntervalSpecificationDTO = App.Data.Alerts.CheckIntervalSpecificationDTO;
import { t } from "@/plugins/i18n";
import dayjs from "dayjs";

const { checkIntervalType, checkIntervalSpecification } = defineProps<{
	checkIntervalType: CheckIntervalType;
	checkIntervalSpecification: CheckIntervalSpecificationDTO;
}>();

function formatDate(dayOfMonth: number): string {
	if (dayOfMonth === -1) {
		return "on the last day at "
	}
	let suffix: string
	if (dayOfMonth >= 11 && dayOfMonth <= 13) {
		suffix = "th"
	} else {
		switch (dayOfMonth % 10) {
			case 1: suffix = "st"; break
			case 2: suffix = "nd"; break
			case 3: suffix = "rd"; break
			default: suffix = "th"; break
		}
	}
	return `on the ${dayOfMonth}${suffix} at `
}

</script>

<template>
	<span>
		{{ t(`alerts.check_types.${checkIntervalType}`) }}
		<template v-if="checkIntervalType === 'hourly'">
			at minute
			{{ dayjs().minute(checkIntervalSpecification.minute).format("mm") }}
		</template>
		<template v-if="checkIntervalType === 'daily'">
			{{
				dayjs()
					.hour(checkIntervalSpecification.hour)
					.minute(checkIntervalSpecification.minute)
					.format("[at] HH:mm")
			}}
		</template>
		<template v-if="checkIntervalType === 'weekly'">
			{{
				dayjs()
					.day(checkIntervalSpecification.day_of_week)
					.hour(checkIntervalSpecification.hour)
					.minute(checkIntervalSpecification.minute)
					.format("[on] dddd [at] HH:mm")
			}}
		</template><template v-if="checkIntervalType === 'monthly'">
			{{
			formatDate(checkIntervalSpecification.day_of_month) +
			dayjs()
				.hour(checkIntervalSpecification.hour)
				.minute(checkIntervalSpecification.minute)
				.format("HH:mm")
			}}
		</template>
	</span>
</template>

<style scoped lang="scss"></style>
